import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { LatLng } from 'shared/types';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import {
  LatLngMetadata,
  UseLatLngMetadata,
  UseLatLngMetadataProps,
} from './useLatLngMetadata.types';

export const fetchLatLngMetadata = async (
  coordinates: LatLng,
  requestAddress: boolean,
): Promise<LatLngMetadata> => {
  const response = await API.get<LatLngMetadata>(`/lat_lng/metadata/`, {
    params: {
      lat: coordinates.lat,
      lng: coordinates.lng,
      ...(requestAddress && { address: true }),
    },
  });
  return response.data;
};

export const useLatLngMetadata = (
  props: UseLatLngMetadataProps,
): UseLatLngMetadata => {
  const { enabled, lat, lng } = props;
  const pinImprovements = useReleaseFlag('pin_drop_improvements');

  const { data, isError, isLoading } = useQuery({
    queryKey: ['latLngMetadata', lat, lng, pinImprovements],
    queryFn: () => fetchLatLngMetadata({ lat, lng }, pinImprovements),
    enabled,
  });

  return {
    latLngMetadata: data,
    isLatLngMetadataFetchError: isError,
    isLatLngMetadataLoading: isLoading,
  };
};
